import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4" data-testid="payment-cancel-page">
      <Card className="max-w-md w-full">
        <CardContent className="pt-8 pb-6 text-center space-y-4">
          <XCircle className="w-16 h-16 text-slate-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold">Pago cancelado</h1>
          <p className="text-slate-600">No se ha realizado ningún cargo. Puedes suscribirte cuando quieras.</p>
          <div className="grid grid-cols-2 gap-2">
            <Button onClick={() => navigate("/suscripcion")} className="h-11 bg-blue-700 hover:bg-blue-800" data-testid="retry-subscribe">
              Volver a intentar
            </Button>
            <Button onClick={() => navigate("/")} className="h-11" variant="outline" data-testid="back-home-cancel">
              Ir al inicio
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
